import type { User } from '../../types/api.types'

export type AnalyticsUserType = 'platform_admin' | 'tenant_admin' | 'tenant_user'

export function getAnalyticsUserType(user: User): AnalyticsUserType {
  if (user.is_platform_admin) {
    return 'platform_admin'
  }
  if (user.role === 'SUPER_ADMIN') {
    return 'tenant_admin'
  }
  return 'tenant_user'
}
